import { Injectable } from '@angular/core';
import { ManifestFilesServiceBase } from 'scaletech-tickets';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class ManifestFilesService extends ManifestFilesServiceBase {

  constructor(http: HttpClient, webApi: WebApiService) {
    super(http, webApi);
  }
}
